import { getFeatureSettings } from '@office-start/feature-settings-service';
import { DevicePermission, PermissionStatus, } from '@office-start/metaos-hub-sdk';
export class NoOpDevicePermissionStorageService {
    constructor(fs) {
        this.featureSettings = {};
        this.featureSettings = fs;
    }
    getPermissions() {
        const permissions = Object.values(DevicePermission).map((permission) => {
            var _a;
            const permissionStatus = ((_a = this.featureSettings.permissionStatus) === null || _a === void 0 ? void 0 : _a.value) ||
                PermissionStatus.NeverAsked;
            return {
                permission,
                status: permissionStatus,
            };
        });
        return Promise.resolve(permissions);
    }
    getPermissionStatus(_permission) {
        var _a;
        const permissionStatus = ((_a = this.featureSettings.permissionStatus) === null || _a === void 0 ? void 0 : _a.value) ||
            PermissionStatus.NeverAsked;
        return Promise.resolve(permissionStatus);
    }
    storePermissionConsent(_permissionState) {
        return Promise.resolve();
    }
}
export class NoOpDevicePermissionService {
    constructor() {
        var _a;
        this.featureSettings = {};
        this.storageService = new NoOpDevicePermissionStorageService(this.featureSettings);
        this.featureSettings = ((_a = getFeatureSettings()) === null || _a === void 0 ? void 0 : _a.result) || {};
    }
    requestUserConsentForPermission(permissions) {
        var _a;
        const permissionStatus = ((_a = this.featureSettings.permissionStatus) === null || _a === void 0 ? void 0 : _a.value) ||
            PermissionStatus.NeverAsked;
        return Promise.resolve({
            permission: permissions,
            status: permissionStatus,
        });
    }
}
//# sourceMappingURL=NoOpDevicePermissionService.js.map